import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import trTR from 'antd/locale/tr_TR';

import { useAuthStore } from './stores/authStore';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Firms } from './pages/Firms';
import { FirmDetail } from './pages/FirmDetail';
import { Users } from './pages/Users';
import { AgentVersions } from './pages/AgentVersions';
import { AgentLogs } from './pages/AgentLogs';
import { Kullanim } from './pages/Kullanim';
import { Dealers } from './pages/Dealers';
import { Announcements } from './pages/Announcements';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={trTR}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="firms" element={<Firms />} />
              <Route path="firms/:id" element={<FirmDetail />} />
              <Route path="dealers" element={<Dealers />} />
              <Route path="users" element={<Users />} />
              <Route path="agent-versions" element={<AgentVersions />} />
              <Route path="kullanim" element={<Kullanim />} />
              <Route path="logs" element={<AgentLogs />} />
              <Route path="announcements" element={<Announcements />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
